import { motion } from "framer-motion";
import { trackTelegramClick, TELEGRAM_URL } from "@/config";

const VARIANTS = {
    chrome: "bg-gradient-to-b from-white to-[#c9ccd4] text-ink shadow-[0_12px_45px_-10px_rgba(255,255,255,0.45)] hover:from-white hover:to-[#e4e7ed]",
    ghost: "border border-white/40 text-white hover:bg-white/10",
    blue: "bg-gradient-to-b from-[#4a90ff] to-[#1677FF] text-white shadow-[0_12px_45px_-10px_rgba(22,119,255,0.8)] hover:from-[#5f9dff] hover:to-[#2f80ff]",
};

const CtaButton = ({
    location = "Hero",
    variant = "chrome",
    className = "",
    children,
    testId,
    small = false,
}) => (
    <motion.a
        href={TELEGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackTelegramClick(location)}
        data-testid={testId}
        whileHover={{ scale: 1.03, y: -2 }}
        whileTap={{ scale: 0.96 }}
        transition={{ type: "spring", stiffness: 400, damping: 22 }}
        className={`inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full font-display font-extrabold uppercase tracking-wide transition-colors duration-300 ${
            small
                ? "px-4 py-2.5 text-[10px] sm:px-5 sm:text-[11px]"
                : "px-8 py-4 text-sm sm:text-base"
        } ${VARIANTS[variant]} ${className}`}
    >
        {children}
    </motion.a>
);

export default CtaButton;
